import { useState } from 'react';
import { useMutation, useQueryClient } from '@tanstack/react-query';
import { getItemWithExpiration } from '../lib/utils';
import { deleteMembershipTemplate, patchRelocateMembership, PatchRelocateMembershipApiType } from '../api/memberShip';

type Props = {
    onPatchRelocateMembershipSuccess?: () => void;
    onDeleteMembershipTemplateSuccess?: () => void;
};

const useMembershipTemplateMutationService = ({
    onPatchRelocateMembershipSuccess,
    onDeleteMembershipTemplateSuccess,
}: Props) => {
    const [authObject] = useState(getItemWithExpiration('authObject'));
    const [authorization] = useState(getItemWithExpiration('authorization'));
    const queryClient = useQueryClient();

    // 회원권 이전하기
    const patchRelocateMembershipMutation = useMutation(
        ['patchRelocateMembershipMutation'],
        async (params: Omit<PatchRelocateMembershipApiType, 'accessToken'>) =>
            patchRelocateMembership({ ...params, accessToken: authorization }),
        {
            onError: (error) => {
                console.log(error);
            },
            onSuccess: async ({ status }) => {
                if (status === 200) {
                    // 이전 후 원/대상 회원 프로필의 수강권 목록이 갱신되도록 무효화(prefix 매칭으로 양쪽 회원 모두 커버)
                    queryClient.invalidateQueries({ queryKey: ['getAllMembershipForMemberQuery'] });
                    queryClient.invalidateQueries({ queryKey: ['getMembershipForMemberQuery'] });
                    onPatchRelocateMembershipSuccess && onPatchRelocateMembershipSuccess();
                }
            },
        }
    );

    // 회원권 템플릿 삭제
    const deleteMembershipTemplateMutation = useMutation(
        ['deleteMembershipTemplateMutation'],
        async (params: { membershipTemplateId: string }) =>
            deleteMembershipTemplate({ ...params, accessToken: authorization }),
        {
            onError: (error) => {
                console.log(error);
            },
            onSuccess: async ({ status }) => {
                if (status === 204) {
                    onDeleteMembershipTemplateSuccess && onDeleteMembershipTemplateSuccess();
                }
            },
        }
    );

    return {
        patchRelocateMembershipMutation,
        deleteMembershipTemplateMutation,
    };
};

export default useMembershipTemplateMutationService;
